export const getCSSPropertyToValue = (data) => {
    let arr =  data.split('#');
    let property = arr[1].split(';');
    let value = `${property[0]}`;
    return value;
}